import { getIamAccount, getIamRoot } from './iamApi'

interface RawUserInfo {
  email: string
  name: string
  picture: string
  given_name?: string
  family_name?: string
}

export interface UserInfo extends RawUserInfo {
  isJrEmployee: boolean
}

interface RawAccountUserInfo extends RawUserInfo {
  account_permissions: string[]
  team_ids: string[]
}

interface AccountUserinfo extends RawAccountUserInfo {
  isJrEmployee: boolean
}

export async function getAccountUserInfo(): Promise<AccountUserinfo | null> {
  const userinfo = (await getIamAccount(
    'userinfo',
  )) as RawAccountUserInfo | null
  return userinfo ? { ...userinfo, isJrEmployee: isJrEmployee(userinfo) } : null
}

export async function getUserInfo() {
  return (await getAccountUserInfo()) || getGlobalUserInfo()
}

async function getGlobalUserInfo() {
  const userinfo = (await getIamRoot('userinfo')) as RawUserInfo
  return { ...userinfo, isJrEmployee: isJrEmployee(userinfo) }
}

function isJrEmployee(userinfo: RawUserInfo) {
  return userinfo.email.endsWith('@justrelate.com')
}
